import React, { PureComponent } from 'react';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import DisplayBoxLogo from '@client/components/displayBox/displayBoxLogo/DisplayBoxLogo';
import DisplayBoxLabel from '@client/components/displayBox/displayBoxLabel/DisplayBoxLabel';
import Image from '@client/components/image/Image';
import ReactLink from '@client/components/reactLink/ReactLink';
import { strings } from '@client/localization/Localization';
import playIcon from '@client/shared/styles/assets/play/play-icon-red.svg';
import themeStyles from '@client/shared/styles/theme/theme-styles.scss';
import styles from './displayBox.scss';

class DisplayBox extends PureComponent {
  getLabelTextColor() {
    return classNames({
      [themeStyles.titleMedium]: !this.props.whiteTitle,
      [themeStyles.titleMediumWhite]: this.props.whiteTitle,
    });
  }

  getOverlay = () => {
    const { itemOverlay = true } = this.props;
    if (itemOverlay)
      return (
        <div className={`${themeStyles.hideOnMobile} ${styles.overlay}`}>
          <img
            className={styles.playIcon}
            src={playIcon}
            alt={strings.playVideo}
          />
        </div>
      );
  };

  getEpisodesCount = () => {
    const { numOfEpisodes } = this.props;
    if (numOfEpisodes !== null && numOfEpisodes !== undefined) {
      return (
        <div
          className={`${themeStyles.episodesCountDark} ${styles.episodesCount}`}
        >
          <span>{numOfEpisodes}</span>
          <span>{strings.episodesCount}</span>
        </div>
      );
    }
  };

  render() {
    const {
      className,
      title,
      description,
      imgSrc,
      alt,
      categoryTitle,
      categoryColor,
      sponsor,
      route,
    } = this.props;

    return (
      <div
        className={
          className ? `${styles.displayBox} ${className}` : styles.displayBox
        }
      >
        <ReactLink to={route}>
          <div className={styles.imageContainerWrapper}>
            <div className={styles.imageContainer}>
              {categoryTitle && (
                <DisplayBoxLabel
                  text={categoryTitle}
                  backgroundColor={categoryColor}
                />
              )}
              {sponsor && (
                <DisplayBoxLogo logo={sponsor.imageUrl} alt={sponsor.title} />
              )}
              <Image className={styles.image} src={imgSrc} alt={alt} />
              {this.getOverlay()}
            </div>
          </div>
          <div className={styles.textBox}>
            {this.getEpisodesCount()}
            <div className={this.getLabelTextColor()}>{title}</div>
            <div>{description}</div>
          </div>
        </ReactLink>
      </div>
    );
  }
}

DisplayBox.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  categoryColor: PropTypes.string,
  categoryTitle: PropTypes.string,
  imgSrc: PropTypes.string,
  alt: PropTypes.string,
  sponsor: PropTypes.object,
  route: PropTypes.string,
  whiteTitle: PropTypes.bool,
  numOfEpisodes: PropTypes.number,
  itemOverlay: PropTypes.bool,
};

export default DisplayBox;
